import React from "react";

const headers = ["Size", "To Fit Waist", "Inseam Length"];
const rows = [
  ["28", "71.1 | 28", "76.2 | 30"],
  ["30", "76.2 | 30", "76.2 | 30"],
  ["32", "81.3 | 32", "76.2 | 30"],
  ["34", "86.4 | 34", "76.2 | 30"],
  ["36", "91.4 | 36", "76.2 | 30"],
];

const guide = [
  ["Waist", "Button the pants, lay them flat and smooth out wrinkles, then measure across the waistband."],
  ["Front Rise", "With pants buttoned and flat, measure from the crotch seam up to the waistband."],
  ["Hip", "Measure across the hip area, usually about 1½ inches below the zipper."],
  ["Thigh", "Measure starting at the crotch seam, ending 1–2 inches below the hip area."],
  ["Length", "Lay the pants flat with outseams aligned and measure from the top of the waistband down."],
  ["Inseam", "Measure the inner seam from the crotch down to the desired leg length."],
  ["Leg Opening", "Lay flat and measure across one side of the leg opening to the other."],
];

const SizeChartBottom = () => {
  return (
    <div className="bg-white p-6 sm:p-8">
      <div className="text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#b28585]">
          Size Guide
        </p>
        <h2 className="font-display text-3xl font-bold text-[#511d00]">
          Men's Bottom Wear
        </h2>
        <p className="mt-1 text-xs text-[#8a7575]">All measurements in CM | INCHES</p>
      </div>

      {/* table */}
      <div className="mx-auto mt-6 max-w-2xl overflow-hidden rounded-xl border border-[#eadcc0]">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#5e3e3e] text-[#f1e7da]">
              {headers.map((h) => (
                <th key={h} className="px-3 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r[0]} className={i % 2 ? "bg-[#fffdf8]" : "bg-white"}>
                {r.map((c, j) => (
                  <td
                    key={j}
                    className={`px-3 py-2.5 ${j === 0 ? "font-bold text-[#511d00]" : "text-[#5e3e3e]"}`}
                  >
                    {c}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* diagram */}
      <div className="mx-auto mt-6 max-w-md overflow-hidden rounded-xl border border-[#eadcc0] bg-[#fffdf8] p-3">
        <img src="https://cdn.kiwisizing.com/the-indian-garage-1653026723071.png" alt="size chart" className="mx-auto" />
      </div>

      {/* guide */}
      <div className="mx-auto mt-6 max-w-2xl">
        <h3 className="mb-3 font-semibold text-[#511d00]">How to Measure</h3>
        <ul className="space-y-2.5 text-sm leading-relaxed text-[#5e3e3e]">
          {guide.map(([label, text]) => (
            <li key={label}>
              <span className="font-semibold text-[#511d00]">{label}: </span>
              {text}
            </li>
          ))}
        </ul>
        <p className="mt-4 text-xs italic text-[#8a7575]">
          Sizes can vary by 2–3 cm as each piece is measured by hand (1 inch =
          2.54 cm). The size on the label may differ slightly from the one
          ordered.
        </p>
      </div>
    </div>
  );
};

export default SizeChartBottom;
